import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Cake} from "../../logic/models/Cake";
import {RecipeModel} from "../../logic/models/RecipeModel";
import InformationList from "../../reusable/Information/InformationList";
import BoxesWrapper from "../../reusable/Layouts/BoxesWrapper";
import {ControlledFormContext} from "../../reusable/ControlledForm/ControlledForm";
import {Utils} from "../../logic/reusable/Utils";
import {IngredientDataHandler} from "../../logic/db/IngredientDataHandler";
import {useTranslation} from "react-i18next";
import {TranslationParser} from "../../translations/TranslationParser";

type ResultZoneProps = {
    recipe: RecipeModel
}

function ResultZone(props: ResultZoneProps) {
    const {recipe} = props
    const [adaptedRecipe, setAdaptedRecipe] = useState(recipe)
    const {formData} = useContext(ControlledFormContext)
    const [ingredients, setIngredients] = useState<Ingredient[]>([])
    const [fetched, setFetched] = useState<boolean>(false)
    const {t} = useTranslation()

    useEffect(() => {
        IngredientDataHandler.getIngredients().then(result => {
            setIngredients(result as Ingredient[]);
            setFetched(true)
        }).catch(reason => {
            console.log(reason)
        })
        IngredientDataHandler.registerIngredientListener(setIngredients)
    }, [])

    useEffect(() => {
        const originalReceipe: Recipe = recipe.copy()
        // originalReceipe.height.value = 10
        // originalReceipe.diameter.value = 10
        const cakeOrignial = new Cake(originalReceipe)
        const newReceipe: Recipe = recipe.copy()
        newReceipe.height.value = Utils.dynamicKeyAccess(formData, "heightOut")
        newReceipe.height.unit = Utils.dynamicKeyAccess(formData, "heightUnitOut")
        newReceipe.diameter.value = Utils.dynamicKeyAccess(formData, "diameterOut")
        newReceipe.diameter.unit = Utils.dynamicKeyAccess(formData, "diameterUnitOut")
        const cakeTarget = new Cake(newReceipe)
        setAdaptedRecipe(new RecipeModel({recipe: cakeOrignial.calcRecipeAdaption(cakeTarget)}))
    }, [formData, recipe])

    return ( fetched ?
        <Fragment>
            <BoxesWrapper className="result-boxes" boxes={[
                <InformationList informations={TranslationParser.parseUnitsLabelSeperated(t, recipe.retrieveListData())} withDivider={true}/>,
                <InformationList informations={TranslationParser.parseUnitsLabelSeperated(t, adaptedRecipe.retrieveListData())} withDivider={true}/>,
            ]}/>
            <BoxesWrapper className="result-boxes-prices" boxes={[
                <output>{recipe.calcPrice(ingredients, "euro")} Euro</output>,
                <output>{adaptedRecipe.calcPrice(ingredients, "euro")} Euro</output>
            ]}/>
        </Fragment> : null

    );
}

export default ResultZone;
